export default "__VITE_ASSET__DnX4YZD$__"